import { SecondaryButton } from 'ui/button';
import { useSelector } from 'react-redux';
import { spacing, caption, body2, colors } from 'ui/theme';
import styled from 'styled-components';
import { selectIsMIApplyButtonFeatureFlagOn } from 'core/userContext';
import { metricSentenceCase } from 'modules/productAnalytics/utils';
import { sanitizeMediumParam, compileSharedUrl } from '../utils';
import { useCampaignAndMetricFiltersContext } from '../context';
import { selectAppliedCrossMetrics } from '../selectors';
import { useGetAllUrlFilters } from '../hooks/useGetAllUrlFilters';

type ComparisonBarTooltipProps = {
  medium: string;
  numberOfCampaigns: number;
  metricName: string;
  value: string | JSX.Element;
};

const HeaderTitle = styled.div`
  padding-bottom: ${spacing.half};
  margin-bottom: ${spacing.half};
  border-bottom: ${spacing.single} solid ${colors.white};
  ${caption};
  color: ${colors.white};
`;

const MetricWrapper = styled.div`
  padding-bottom: ${spacing.half};
  ${body2};
  color: ${colors.white};
`;

const StyledSecondaryButton = styled(SecondaryButton)`
  width: 100%;
`;

export const ComparisonBarTooltip = ({
  medium,
  numberOfCampaigns = 0,
  metricName,
  value,
}: ComparisonBarTooltipProps) => {
  const isMIApplyButtonFFOn = useSelector(selectIsMIApplyButtonFeatureFlagOn);

  const { setSelectedMediums, appliedCampaignFilters } = useCampaignAndMetricFiltersContext();
  const buttonText = metricSentenceCase(
    numberOfCampaigns >= 1
      ? `View ${numberOfCampaigns === 1 ? 'this' : 'these'} ${numberOfCampaigns} ${medium} ${
          numberOfCampaigns === 1 ? 'campaign' : 'campaigns'
        }`
      : `View ${medium} campaigns`,
  );
  const appliedCrossMetrics = useSelector(selectAppliedCrossMetrics);
  const applyButtonLinkout = compileSharedUrl({
    ...useGetAllUrlFilters(),
    selectedMediums: [sanitizeMediumParam(medium)],
    campaignFilters: appliedCampaignFilters,
    selectedCrossMetrics: appliedCrossMetrics,
  });
  return (
    <div>
      <HeaderTitle>{medium} campaigns</HeaderTitle>
      <MetricWrapper>
        {metricName}: {value}
      </MetricWrapper>
      {isMIApplyButtonFFOn ? (
        <a href={applyButtonLinkout?.completeUrl}>
          <StyledSecondaryButton>{buttonText}</StyledSecondaryButton>
        </a>
      ) : (
        <div>
          <StyledSecondaryButton onClick={() => setSelectedMediums([sanitizeMediumParam(medium)])}>
            {buttonText}
          </StyledSecondaryButton>
        </div>
      )}
    </div>
  );
};
